import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
        warning:
          'border-transparent bg-yellow-100 text-yellow-800 dark:bg-yellow-400/10 dark:text-yellow-500 shadow hover:bg-yellow-100/80 dark:hover:bg-yellow-400/20',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-red-100 text-red-800 dark:bg-red-400/10 dark:text-red-500 shadow hover:bg-red-100/80 dark:hover:bg-red-400/20',
        outline: 'text-foreground',
        primary:
          'border-transparent bg-blue-100 text-blue-800 dark:bg-blue-400/10 dark:text-blue-500 shadow hover:bg-blue-100/80 dark:hover:bg-blue-400/20',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
